import { render, staticRenderFns } from "./DataTablePaginationSizeConfig.vue?vue&type=template&id=0d7de70a&"
import script from "./DataTablePaginationSizeConfig.vue?vue&type=script&lang=ts&"
export * from "./DataTablePaginationSizeConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports